import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance';
import { keys as localStorageKeys } from '@confluence/storage-manager/entry-points/LocalStorageKeys';

const EXPIRY_IN_7_DAYS = 60 * 60 * 24 * 7;

export const isFeatureVisited = async (): Promise<boolean> => {
	try {
		if (getFeatureVisited()) {
			return true;
		}
		void snoozeFeatureFor7Days();
		return false;
	} catch (error: any) {
		return true;
	}
};

export const getFeatureVisitedCount = (): number => {
	const value = localStorage.getItem(getVisitedCountStorageKey());
	return parseInt(value, 10) || 0;
};

export const increaseFeatureVisitedCount = () => {
	const currentCount = getFeatureVisitedCount();
	localStorage.setItem(getVisitedCountStorageKey(), currentCount + 1);
};

const snoozeFeatureFor7Days = () => {
	setFeatureVisited(EXPIRY_IN_7_DAYS);
};

const setFeatureVisited = (expire: number) => {
	localStorage.setItem(getVisitedStorageKey(), true, expire);
};

const getFeatureVisited = (): boolean => localStorage.getItemAsBoolean(getVisitedStorageKey());

function getVisitedStorageKey(): string {
	return localStorageKeys.CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_KEY;
}

function getVisitedCountStorageKey(): string {
	return localStorageKeys.CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_COUNT;
}
